import withDomainSpecific from "./with-domain-specific";

const config = {
    environment: process.env.NODE_ENV,
    websiteUrl: undefined,
    api: process.env.REACT_APP_API,
    sessionTimeoutInMinutes:  parseInt(process.env.REACT_APP_SESSION_TIMEOUT ?? '') || 7,
    debug: process.env.REACT_APP_DEBUG && process.env.REACT_APP_DEBUG.toLowerCase() === 'true',
    ssoConfig: {
        authority: undefined,
        client_id: 'ReactsCustomerAdmin',
        response_type: 'code',
        redirect_uri: undefined,
        silent_redirect_uri: undefined,
        post_logout_redirect_uri : undefined,
        scope: 'openid profile api1 https://www.iitreacts.com',
        automaticSilentRenew: false,
        loadUserInfo: false,
        monitorSession: false
    },
    uiConfig: {
        defaultRowsPerPage: 5
    },
    usageStats: {
        // Month 9 is october, JS Dates are 0 based
        rolloutDate: new Date(2021, 9, 1)
    }
};

export default withDomainSpecific(config)(window.location);
